import { create } from 'zustand'

export type SyncStatus = 'local' | 'loading' | 'synced' | 'pending' | 'offline' | 'error'

interface SyncState {
  status: SyncStatus
  pending: number
  error: string | null
  cursor: string | null
  setSync: (updates: Partial<Omit<SyncState, 'setSync'>>) => void
}

export const useSyncStore = create<SyncState>((set) => ({
  status: 'local', pending: 0, error: null, cursor: null,
  setSync: (updates) => set(updates),
}))
